import { createContext, ReactNode, useContext, useState } from "react";

type DrawerContextType = {
    isDrawerOpen: boolean;
    openDrawer: () => void;
    closeDrawer: () => void;
};

const DrawerContext = createContext<DrawerContextType | undefined>(undefined);

export const DrawerProvider = ({ children }: { children: ReactNode }) => {
    const [isDrawerOpen, setDrawerOpen] = useState(false);

    const openDrawer = () => setDrawerOpen(true);
    const closeDrawer = () => setDrawerOpen(false);

    return <DrawerContext.Provider value={{ isDrawerOpen, openDrawer, closeDrawer }}>{children}</DrawerContext.Provider>;
};

export const useDrawer = (): DrawerContextType => {
    const context = useContext(DrawerContext);
    if (!context) {
        throw new Error("useDrawer must be used within a DrawerProvider");
    }
    return context;
};
